import { render, staticRenderFns } from "./TranslationEditor.vue?vue&type=template&id=dae6968a&scoped=true&"
import script from "./TranslationEditor.vue?vue&type=script&lang=js&"
export * from "./TranslationEditor.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEditor.vue?vue&type=style&index=0&id=dae6968a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae6968a",
  null
  
)

export default component.exports